<template>
  <div class="intro-list" :class="{ hidden: collapsed }">
    <span class="soc-sea" v-if="social">
      <span :class="`soc-ico soc-${social}`"></span>
      {{ socialName }}
    </span>

    <span class="soc-sea" v-if="email">
      <!-- <span :class="`soc-ico soc-${social}`"></span> -->
      {{ email }} ({{ pages.length }}/{{ getProfile?.pageLimit || 0 }})
      <button type="button" class="group-toggle" @click="collapsed = !collapsed">
        <i :class="collapsed ? 'bi bi-chevron-down' : 'bi bi-chevron-up'"></i>
      </button>
    </span>

    <span class="soc-sea" v-if="categoryName">
      <span :class="`cat-indicator ${getCategoryColorClass}`"></span>
      {{ categoryName }}
      <button 
        v-if="categoryId !== 'uncategorized'"
        class="cat-edit" 
        @click="openCategoryManager" 
      >
        <i class="bi bi-gear"></i>
      </button>
      <button type="button" class="group-toggle" @click="collapsed = !collapsed">
        <i :class="collapsed ? 'bi bi-chevron-down' : 'bi bi-chevron-up'"></i>
      </button>
    </span>
    <div class="p-list" v-show="!collapsed">
      <table>
        <thead>
          <tr>
            <th
              :class="classTableHead('name')"
              @click="toggleSort('name')"
            >
              <label class="inp-chk" 
              v-if="categoryName && categoryId !== 'uncategorized'"
              @click.stop>
                <input
                type="checkbox"
                class="inp-chk"
                :checked="isCategoryAllSelected"
                @change="selectAllFromCategory"
              />
              </label>
              
              {{ $t('INTRO_TABS_NAME') }}
            </th>
            <th
              :class="classTableHead('followers')"
              @click="toggleSort('followers')"
            >
              {{ $t('INTRO_TABS_FOLLOWERS') }}
            </th>
            <th
              :class="classTableHead('growth')"
              @click="toggleSort('growth')"
            >
              {{ $t('INTRO_TABS_GROWTH') }}
            </th>
            <th
              :class="classTableHead('reach')"
              @click="toggleSort('reach')"
            >
              {{ $t('INTRO_TABS_REACH') }}
            </th>
            <th 
                :class="classTableHead('er')" 
                @click="toggleSort('er')">
              {{ $t('INTRO_TABS_ER') }}, %
            </th>
            <th v-if="!social" class="nonsort">{{ $t('INTRO_TABS_SOCIAL') }}</th>
            <th v-if="!categoryName && hasCategories" class="nonsort">{{ $t('INTRO_TABS_CATEGORIES') }}</th>
            <th class="nonsort">{{ $t('INTRO_TABS_LINK') }}</th>
            <th class="nonsort">{{ $t('INTRO_TABS_DELETE') }}</th>
          </tr>
        </thead>
        <tbody>
          <intro-line
            :page="page"
            :social="social"
            :show-categories="!categoryName && hasCategories"
            :categories="getCategories"
            :key="index"
            v-for="(page, index) in sortedPages"
          ></intro-line>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import IntroLine from "./Intro-line";
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  CATEGORIES_SET_MANAGER_VISIBLE,
  CATEGORIES_SET_CURRENT,
} from "../../../store/actions/categories";
import {
  INTRO_SET_SELECTED,
} from "../../../store/actions/intro";
import { SELECTED_PAGES_LIMIT } from "../../../store/modules/intro";

export default {
  name: "intro-list",
  components: {
    IntroLine,
  },
  props: {
    pages: {
      type: Array,
      required: true,
    },
    social: {
      type: String,
    },
    socialName: {
      type: String,
    },
    email: {
      type: String,
    },
    categoryName: {
      type: String,
    },
    categoryId: {
      type: [Number, String],
    },
  },
  watch: {
    categoryId: {
      handler(newId) {
        this.loadCategoryColor();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['getProfile', 'getCategories']),
    getCategoryColorClass() {
      if (this.categoryId === 'uncategorized' || !this.categoryId) {
        return 'gray-back'; // Default color for uncategorized
      }
      
      return this.categoryColor + '-back';
    },
    hasCategories() {
      return this.getCategories && this.getCategories.length > 0;
    },
    isCategoryAllSelected() {
      if (!this.categorySelectedIds.length) return false;
      return this.categorySelectedIds.some(hashId => {
        const page = this.pages.find(p => p.hash_id === hashId);
        return page && page.isSelected;
      });
    },
    sortedPages() {
      if (this.sort[this.sort.type] === 0) return this.pages;
      const params = {
        name: "owner_name",
        followers: "followers",
        growth: "growth",
        reach: "reach_avg",
        er: "er",
      };
      const sortBy = params[this.sort.type];
      const copyPages = [...this.pages];
      return copyPages.sort((pageA, pageB) => {
        let a = pageA[sortBy];
        let b = pageB[sortBy];
        if (this.sort.type === 'name') {
          a = a ? a.toString() : '';
          b = b ? b.toString() : '';
          const compareResult = a.localeCompare(b, undefined, { sensitivity: 'accent' });
          if (this.sort[this.sort.type] === 1) {
            return -compareResult;
          } else if (this.sort[this.sort.type] === 2) {
            return compareResult;
          }
        } else {
          a = Number(a);
          b = Number(b);
          if (isNaN(a)) a = -Infinity;
          if (isNaN(b)) b = -Infinity;
          if (this.sort[this.sort.type] === 1) {
            return b - a;
          } else if (this.sort[this.sort.type] === 2) {
            return a - b;
          }
        }
        return 0;
      });
    },
  },
  mounted() {},
  methods: {
    ...mapMutations([CATEGORIES_SET_MANAGER_VISIBLE, CATEGORIES_SET_CURRENT]),
    ...mapActions([INTRO_SET_SELECTED]),
    
    toggleSort(type) {
      const current = this.sort[type];
      this.sort = {
        name: 0,
        followers: 0,
        growth: 0,
        reach: 0,
        er: 0,
        type,
        [type]: (current + 1) % 3,
      };
    },
    classTableHead(type) {
      const status = this.sort[type];
      if (status === 0) return "";
      if (status === 1) return "sort-by-bot down";
      if (status === 2) return "sort-by-bot up";
    },
    openCategoryManager() {
      if (this.categoryId && this.categoryName) {
        // Find the full category object
        const category = this.$store.getters.getCategories.find(cat => cat.id === this.categoryId);
        if (category) {
          this[CATEGORIES_SET_CURRENT](category);
          this[CATEGORIES_SET_MANAGER_VISIBLE](true);
        }
      }
    },
    
    selectAllFromCategory() {
      if (!this.sortedPages || this.sortedPages.length === 0) return;
      
      const finishedPages = this.sortedPages.filter(page => page.status === 'finished');
      const topPages = finishedPages.slice(0, SELECTED_PAGES_LIMIT);
      
      if (this.isCategoryAllSelected) {
        this.categorySelectedIds.forEach(hashId => {
          const page = this.pages.find(p => p.hash_id === hashId);
          if (page && page.isSelected) {
            this[INTRO_SET_SELECTED](page);
          }
        });
        this.categorySelectedIds = [];
      } else {
        topPages.forEach(page => {
          if (!page.isSelected) {
            this[INTRO_SET_SELECTED](page);
            if (!this.categorySelectedIds.includes(page.hash_id)) {
              this.categorySelectedIds.push(page.hash_id);
            }
          }
        });
      }
    },
    
    async loadCategoryColor() {
      if (this.categoryId === 'uncategorized' || !this.categoryId) {
        this.categoryColor = 'gray';
        return;
      }
      
      try {
        const { getCategoryColor } = await import("../../../utils/categoryColors");
        const color = getCategoryColor(this.categoryId);
        this.categoryColor = color || 'gray';
      } catch (error) {
        console.error('Error loading category color:', error);
        this.categoryColor = 'gray';
      }
    },
  },
  data() {
    return {
        sort: {
        name: 0,
        followers: 0,
        growth: 0,
        reach: 0,
        er: 0,
        type: "name",
      },
      categoryColor: 'gray',
      categorySelectedIds: [],
      collapsed: false,
    };
  },
};
</script>
